import React, { useEffect, useState } from "react";
import { LogoMark } from "./LogoMark";

const NAV_LINKS = [
	{ label: "Features", href: "#features" },
	{ label: "Pricing", href: "#pricing" },
	{ label: "FAQ", href: "#faq" },
];

export function Navbar() {
	const [scrolled, setScrolled] = useState(false);

	useEffect(() => {
		const onScroll = () => setScrolled(window.scrollY > 20);
		window.addEventListener("scroll", onScroll, { passive: true });
		return () => window.removeEventListener("scroll", onScroll);
	}, []);

	const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
		e.preventDefault();
		const target = document.querySelector(href);
		if (target) {
			target.scrollIntoView({ behavior: "smooth" });
		}
	};

	return (
		<nav
			className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
				scrolled
					? "glass border-b border-white/10 shadow-lg shadow-black/20"
					: "bg-transparent"
			}`}
		>
			<div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4">
				{/* Logo + Wordmark */}
				<a href="/" className="flex items-center gap-2.5">
					<LogoMark
						size={28}
						className="drop-shadow-[0_0_8px_rgba(219,36,30,0.4)]"
					/>
					<span className="text-lg font-bold tracking-tight text-white">
						COMPS<span className="text-[#db241e]">.red</span>
					</span>
				</a>

				{/* Nav Links */}
				<div className="hidden items-center gap-8 md:flex">
					{NAV_LINKS.map((link) => (
						<a
							key={link.href}
							href={link.href}
							onClick={(e) => handleNavClick(e, link.href)}
							className="text-sm text-zinc-400 transition-colors hover:text-white"
						>
							{link.label}
						</a>
					))}
				</div>

				{/* CTA Buttons */}
				<div className="flex items-center gap-3">
					<a
						href="/signup"
						className="hidden text-sm text-zinc-400 transition-colors hover:text-white sm:block"
					>
						Sign In
					</a>
					<a
						href="/signup"
						className="rounded-lg bg-[#db241e] px-4 py-2 text-sm font-medium text-white transition-all hover:bg-[#c41f1a] hover:shadow-lg hover:shadow-red-900/30"
					>
						Start Free Trial
					</a>
				</div>
			</div>
		</nav>
	);
}
